import type { User } from "./user.model";
import type { LegacyResponse } from "../../core/service/response.model";

export interface AuthData {
  userEmail: string;
  userPassword: string;
}

export interface NewUser {
  userName: string;
  firstName: string;
  lastName: string;
  userPassword: string;
  userEmail: string;
  confirmPassword: string;
  countryCode: string;
  token?: string;
  terms: boolean;
  privacy: boolean;
  funnel?: string;
}

interface Token {
  token: string;
  refreshToken: string;
}

export type AuthResponse = LegacyResponse<User> & Token;
export type RegisterResponse = LegacyResponse<Pick<NewUser, "userName">> & { id: string };

export type AuthenticatedUserRegisterData = Pick<NewUser, "firstName" | "lastName"> & {
  affiliateId: string | null;
};

export type AuthProvider = "GOOGLE" | "APPLE" | "FACEBOOK";

export enum FirebaseErrorCode {
  INVALID_CREDENTIAL = "auth/invalid-credential",
  TOO_MANY_REQUESTS = "auth/too-many-requests",
  ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL = "auth/account-exists-with-different-credential",
}
